module.exports = __webpack_public_path__ + "images/emoji/penguin.bd4e0b339b7e18219ae8.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/penguin.png
// module id = 999w
// module chunks = 2